import { getBootstrapConfig } from 'core/window/windowService';
import { SIDE_SHEET_OFFSET } from 'core-framework/constant/DetailPageModularConstant';

export const scrollToTargetAdjusted = (selector: string, offset = 0, documentArg = document, windowArg = window) => {
    const element = documentArg.querySelector(selector);
    if (!element) return;

    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + windowArg.scrollY - offset;
    const config = getBootstrapConfig();
    const isPageForSimCardEnabled = config.behavior.featureExperiments.featureBehavior.DetailPageForSimCard;

    const overlay = document.querySelector('[data-element-name="detail-page-info-overlay-side-sheet"]') as HTMLElement;

    if (overlay && isPageForSimCardEnabled) {
        const overlayScrollTop = overlay.scrollTop;
        const targetScrollPosition = overlayScrollTop + elementPosition - offset - SIDE_SHEET_OFFSET;

        overlay.scrollTo({
            top: targetScrollPosition,
            behavior: 'smooth',
        });
    } else {
        windowArg.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }
};

export const getDocument = (documentArg = document): Document => {
    return documentArg;
};

export const getWindow = (windowArg = window): Window => {
    return windowArg;
};

export const getLocationHref = (windowArg = window) => getWindow(windowArg)?.location?.href;
